module.exports = __webpack_public_path__ + "img/1.91ec7c4e.png";